import { render } from "./LoadIndicator.vue?vue&type=template&id=1c0bbd7f&ts=true"
import script from "./LoadIndicator.vue?vue&type=script&lang=ts"
export * from "./LoadIndicator.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__